import { render, staticRenderFns } from "./NewInvoices.vue?vue&type=template&id=16601820"
import script from "./NewInvoices.vue?vue&type=script&lang=js"
export * from "./NewInvoices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports